












import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component({})
export default class CoreIcon extends Vue {
    @Prop() public icon!: string
    @Prop() public clickable!: boolean
    @Prop() public itemSize!: number

    public get additionalClasses() {
        return {
            [`el-${this.icon}`]: true,
            clickable: this.clickable,
        };
    }

    public clickHandler() {
        if (this.clickable) this.emitClick();
    }

    @Emit('click')
    public emitClick() {
        return;
    }

}
